import { createContext, useReducer } from 'react';

import reducer from './ComponentPropertiesReducer';

export const initialState = {
    isSaving: false,
    isPublishing: false,
    changeTrack: {
        isGeneralPropertiesChanged: false,
        isAttributeFormBuilderChanged: false,
        isActionTableChanged: false,
        isAttributeTableChanged: false,
        isReferenceTableChanged: false
    },
    fetchedValues: {
        generalProperties: {},
        actionTable: {},
        attributeTable: {},
        referenceTable: {}
    },
    generalProperties: {},
    actionTable: {
        isInitialized: false,
        showCreateActionDialog: false,
        newActionParentId: "",
        showUpdateActionDialog: false,
        updateActionId: "",
        actions: [],
    },
    attributeTable: {
        loading: true,
        attributes: [],
        selectedAttributeId: -1,
        isSyncedComponentsChanged: false,
    },
    attributeFormBuilder:{
        formBuilderLoading: true,
        steps: [],
        selectedStepId: "",
        formActions: [],
        showEditColumnPanel: false,
        editingColumn: null,
    },
    formBuilderAttributes: {
        loading: true,
        attributes: [],
        selectedAttributeId: -1,
        showSyncAttributeDialog: false,
    },
    referenceTable: {
        references: []
    },
    validation: {
        hasErrors: false,
        errors: {}
    }
};

const ComponentPropertiesContext = createContext(initialState);

export function ComponentPropertiesProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ComponentPropertiesContext.Provider value={[state, dispatch]}>
            {children}
        </ComponentPropertiesContext.Provider>
    );
}

export default ComponentPropertiesContext;
